import React, { FC } from 'react';
import styled from '@emotion/styled';
import useCountdownTimer from '@/common/countdownTimer/useCountdownTimer';
import { TimerContainer } from '@/common/countdownTimer/atoms/TimerContainer';
import { TimerBannerText } from '@/common/countdownTimer/atoms/TimerBannerText';
import { TimerBannerSection } from '@/common/countdownTimer/atoms/TimerBannerSection';
import { TimerDisplay } from '@/common/countdownTimer/atoms/TimerDisplay';
import { ClockIcon } from '@/common/countdownTimer/icons/ClockIcon';
import { TimeValue } from '@/common/countdownTimer/atoms/TimeValue';
import { TimeUnit } from '@/common/countdownTimer/atoms/TimeUnit';

export type TimerVariant = 'deals' | 'sidekicks' | 'recipe';

export interface CountdownTimerProps {
  intervalStartTime: string;
  duration: string;
  dealName: string; 
  $variant?: TimerVariant;
}

const ScreenReaderOnly = styled.div`
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    white-space: nowrap;
    width: 1px;
`;

const CountdownTimer: FC<CountdownTimerProps> = ({ intervalStartTime, duration, dealName, $variant }) => {
  const { timerText, hours, minutes, seconds, screenReaderText, timerAccessibilityEnabled } = useCountdownTimer({ intervalStartTime, duration, dealName });

  return (
    <TimerContainer $variant={$variant} data-testid="countdown-timer">
      <TimerBannerText $variant={$variant}>
        {timerText}
      </TimerBannerText>
      <TimerBannerSection $variant={$variant} aria-live="off">
        <TimerDisplay>
          <ClockIcon />
          <TimeValue>{hours}</TimeValue><TimeUnit>h</TimeUnit> <TimeUnit>:</TimeUnit>
          <TimeValue>{minutes}</TimeValue><TimeUnit>m</TimeUnit> <TimeUnit>:</TimeUnit>
          <TimeValue>{seconds}</TimeValue><TimeUnit>s</TimeUnit>
        </TimerDisplay>
      </TimerBannerSection>
      {timerAccessibilityEnabled && (
        <ScreenReaderOnly aria-live="polite" role="status">
          {screenReaderText}
        </ScreenReaderOnly>
      )}
    </TimerContainer>
  );
};

export default CountdownTimer;
